import request from '@/plugins/axios'

export default {
    //获取企业列表
    getCompList(params) {
        return request.get('Yunos/Comp/CompPageList', {params})
    },
    //加入企业
    joinComp(compId) {
        return request.get(`Yunos/Employee/AddUserJoinComp?compId=${compId}`)
    },
    //企业认证
    cerifyComp(data) {
        return request.post('Yunos/Comp/AddCompExamineLog', data)
    },
    // 获取行业
    getIndustryByPid(pid) {
        return request.get(`Yunos/CompIndustryCategory/MdIndustryCategory?pid=${pid}`)
    },
    //创建企业
    createComp(data) {
        return request.post('/Yunos/Comp/AddComp', data)
    },
    //获取企业信息
    getCompInfo(id) {
        return request.get(`/Yunos/Comp/CompInfo?compId=${id}`)
    },
    //获取用户企业列表
    getUserComp() {
        return request.get(`/Yunos/User/UserCompList`)
    },
    //获取审核中企业状态
    getCertifyLevel(id) {
        return request.get(`/Yunos/Comp/CompLevelByComp`)
    },
    //获取审核记录详情
    getCertifyInfo(id) {
        return request.get(`/Yunos/Comp/CompExamineLogInfo`)
    }
}